<template>
  <div class="simulateur-express-vue">
   <div class="title"><i class="icon-simulateurs"></i> Simulateur</div>
    <div class="sub-title"><i class="fa fa-clock-o"></i> Express</div>
   <div class="simulateur-express-form">
       <div class="form-group">
            <label>Montant</label>
            <cleave v-on:input="calculMensualite()" v-model="montant" :options="cleaveOptionsDecimal"></cleave>
            <span class="unit">€</span>
       </div>
        <div class="form-group">
            <label>Durée et taux</label>
            <select v-on:change="calculMensualite();calculMontant()" v-model="duree"> 
                <option :value="taux.duree" v-for="taux in tauxSimulateurs">Sur {{taux.duree}} ans ({{taux.taux.toFixed(2)}}%)</option>
            </select>
       </div>
      <div class="form-group">
            <label>Mensualités</label>
            <cleave v-on:input="calculMontant()" v-model="mensualite" :options="cleaveOptionsDecimal"></cleave>
            <span class="unit">€</span>
       </div>
   </div>
  
  </div>
</template>

<script>
import common from './common.js'
import Vue from 'vue'

Vue.filter('formatNumber', function(number) {
  if (number) {
    return number.toFixed(2)
  }
})

export default {
  mounted () {
    this.taux = window.taux
    this.tauxSimulateurs = window.tauxSimulateurs
    let tmpDuree = this.tauxSimulateurs[0]
    if(tmpDuree) {
        this.duree = tmpDuree.duree
    }
  },
  computed: {
    tauxAnnuel () {
       let item = this.tauxSimulateurs.find((item) => {
          if(item.duree === this.duree) {
            return item
          }
      })
      if(item) {
        return item.taux
      }
     
    },
    tauxAnnuelSousUn () {
      return this.tauxAnnuel / 100
    },
    tauxMensuelSousUn () {
      return this.tauxAnnuelSousUn / 12
    },
    dureeCreditEnMois () {
      return this.duree * 12
    },
    mensualiteBrute () {
      return  this.montant / (this.duree * 12)
    },
    coutEmprunt () {
      return this.mensualite * this.dureeCreditEnMois
    }
  
    
  },
  data () {
    return {
      tauxSimulateurs: [],
      taux: {},
      duree: null,
      montant: null,
      mensualite: null,
      cleaveOptionsDecimal: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: ' '
      },
      cleaveOptionsInteger: {
          numeral: true,
          numeralDecimalMark: '',
          delimiter: ' '
      },
        
    }
  },
  methods: {
    calculate () {
     
    },
    calculMontant () {
        this.montant =  (((1 -  Math.pow( 1 + this.tauxMensuelSousUn, -this.dureeCreditEnMois)) * this.mensualite) /  this.tauxMensuelSousUn)
    },
    calculMensualite () {
        this.mensualite = (this.montant * this.tauxMensuelSousUn ) / (1 -  Math.pow( 1 + this.tauxMensuelSousUn  , -this.dureeCreditEnMois)) 
    }

  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/js/vue/components/SimulateurExpress.vue